// @flow
import React from 'react';
import Slider from 'react-slick';

import { WhitePanel } from '../UI';
import { TransportCard } from '../Cards';

import transportData from './data';

import './featured-transport.css';

type GalleryArrowProps = {
  onClick: () => void,
  direction: string,
};

const GalleryArrow = ({ onClick, direction }: GalleryArrowProps) => (
  <div className={`control ${direction}`}>
    <a role="button" onClick={onClick}>
      <div className="circle">
        <i className={`icon icon-hg-chev-${direction}`} />
      </div>
    </a>
  </div>
);

const Settings = {
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  swipe: true,
  dots: false,
  centerPadding: '10px',
  nextArrow: <GalleryArrow direction="right" />,
  prevArrow: <GalleryArrow direction="left" />,
  responsive: [
    {
      breakpoint: 1200,
      settings: { infinite: false, slidesToShow: 3, slidesToScroll: 1 },
    },
    {
      breakpoint: 1024,
      settings: { infinite: false, slidesToShow: 3, slidesToScroll: 1 },
    },
    { breakpoint: 991, settings: { slidesToShow: 3, slidesToScroll: 1 } },
    { breakpoint: 750, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 500, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  ],
};

export default function FeaturedTransportSlider() {
  const { title, data } = transportData;
  return (
    <WhitePanel>
      <h2>{title}</h2>
      <Slider {...Settings} className="featured-slider">
        {data.map((t) => (
          <div key={t.name} className="item">
            <TransportCard cardData={t} />
          </div>
        ))}
      </Slider>
    </WhitePanel>
  );
}



// WEBPACK FOOTER //
// ./src/components/FeaturedTransportSlider/FeaturedTransportSlider.jsx